import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import { isInternalProcessRoute } from '@/utils/misc';

import Login from '@/views/Login';
import Logout from '@/views/Logout';
import Grid from '@/views/Grid';
import Pending from '@/views/Pending';
import PendingFundsUndoChanges from '@/views/PendingFundsUndoChanges';
import ImportApprovals from '@/views/ImportApprovals';
import ImportReviews from '@/views/ImportReviews';
import ImportLineups from '@/views/ImportLineups';
import ImportPreferredFunds from '@/views/ImportPreferredFunds';
import AddFundToSeries from '@/views/AddFundToSeries';
import ManageSeries from '@/views/ManageSeries';
import NotFound from '@/views/NotFound';
import Reports from '@/views/Reports';
import CreateCustomFunds from '@/views/CreateCustomFunds';
import UpdateFundReviewStatus from '@/views/UpdateFundReviewStatus';
import FundReviewNotes from '@/views/FundReviewNotes';
import ReviewStatusAcrossClients from '@/views/ReviewStatusAcrossClients';
import SelectFundReplacement from '@/views/SelectFundReplacement';

Vue.use(Router);

const routes = [
  {
    path: '/Login',
    alias: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/logout',
    name: 'logout',
    component: Logout,
  },
  {
    path: '/',
    name: 'grid',
    component: Grid,
  },
  {
    path: '/universe/client/:clientId',
    name: 'clientGrid',
    component: Grid,
    props: true,
  },
  {
    path: '/review-status-across-clients/:fundId/fiduciary-fund-id/:fiduciaryFundId',
    name: 'reviewStatusAcrossClients',
    component: ReviewStatusAcrossClients,
    props: true,
  },
  {
    path: '/update-review-status/:fundId',
    name: 'updateFundReviewStatus',
    component: UpdateFundReviewStatus,
    props: true,
  },
  {
    path: '/pending',
    name: 'pending',
    component: Pending,
  },
  {
    path: '/pending/funds/undo-changes/:selectedClientId',
    name: 'pendingFundsUndoChanges',
    component: PendingFundsUndoChanges,
    props: true,
  },
  {
    path: '/import-lineups',
    name: 'importLineups',
    component: ImportLineups,
  },
  {
    path: '/import-approvals',
    name: 'importApprovals',
    component: ImportApprovals,
  },
  {
    path: '/import-preferred-funds',
    name: 'importPreferredFunds',
    component: ImportPreferredFunds,
  },
  {
    path: '/import-reviews',
    name: 'importReviews',
    component: ImportReviews,
  },
  {
    path: '/add-fund-to-series/:fundSlug',
    name: 'addFundToSeries',
    component: AddFundToSeries,
    props: true,
  },
  {
    path: '/universe/client/:clientId/manage-series/:seriesId',
    name: 'manageSeries',
    component: ManageSeries,
    props: true,
  },
  {
    path: '/reports',
    name: 'reports',
    component: Reports,
    props: true,
  },
  {
    path: '/create-custom-funds',
    name: 'createCustomFunds',
    component: CreateCustomFunds,
    props: true,
  },
  {
    path: '/fund-review-notes/:fundId',
    name: 'fundReviewNotes',
    component: FundReviewNotes,
    props: true,
  },
  {
    path: '/fund-replacement',
    name: 'selectFundReplacement',
    component: SelectFundReplacement,
    props: true,
  },
  {
    path: '/404',
    name: 'notFound',
    component: NotFound,
  },
  {
    path: '*',
    redirect: '/404',
  },
];

const router = new Router({
  routes,
});

const unsafeRouteNames = [
  'login',
  'logout',
  'notFound',
];

router.beforeEach((to, from, next) => {
  // Layout definitions
  if (isInternalProcessRoute(to)) {
    store.dispatch('setIsInternalProcessLayout', true);
    store.dispatch('hideNavigationBar');
  } else {
    store.dispatch('setIsInternalProcessLayout', false);
    store.dispatch('showNavigationBar');
  }

  // Security
  if (unsafeRouteNames.every((unsafeRouteName) => unsafeRouteName !== to.name)) {
    if (!store.getters['user/hasAccessToBrowseIn']) {
      return next({ path: '/login' });
    }
  }
  return next();
});

export default router;
